<template>
  <v-toolbar id="header-toolbar" color="primary" fixed dark app>
    <v-toolbar-title class="ml-0 pl-0 hidden-md-and-up">
      <v-toolbar-side-icon @click.stop="handleDrawerToggle"></v-toolbar-side-icon>
    </v-toolbar-title>
    <v-toolbar-title class="ml-0 hidden-sm-and-down">
      <img :src="computeLogo" height="46" />
    </v-toolbar-title>
    <page-header v-if="$route.meta.breadcrumb"></page-header>
    <div v-else class="hidden-sm-and-down">
      <v-layout row class="layout pl-2 app--page-header">
        <div class="page-header-left">
          <h4 class="pr-3 font-weight-medium">Csain tiro con l'arco - portale gare</h4>
          - v.3.55 - {{ getEnviroenment }}
        </div>
      </v-layout>
    </div>
    <v-spacer></v-spacer>
    <app-menu class="app--menu"></app-menu>
    <v-btn @click="handleFullScreen()" icon>
      <v-icon>fullscreen</v-icon>
    </v-btn>

    <v-menu :nudge-bottom="10" :nudge-right="300" offset-y origin="center center" transition="slide-y-transition">
      <v-btn slot="activator" flat>
        <v-avatar size="30px">
          <img :src="userPicture" />
        </v-avatar>
        <small v-if="userData && role == 'ASSOCIATO'" class="ml-2">{{ userData.Cognome }} {{ userData.Nome }}</small>
        <small v-if="userData && role != 'ASSOCIATO' && role != 'ADMIN'" class="ml-2">{{ userData.Denominazione }}</small>
        <small v-if="userData && role == 'ADMIN'" class="ml-2">ADMIN</small>
      </v-btn>
      <v-list v-if="userData" class="pa-0">
        <v-list-tile
          v-for="(item, index) in items"
          :key="index"
          :to="!item.href ? { name: item.name } : null"
          :href="item.href"
          :disabled="item.disabled"
          :target="item.target"
          @click="item.click"
          ripple="ripple"
          rel="noopener"
        >
          <v-list-tile-action v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title :class="{ 'body-2 secondary--text': !item.icon }">{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-toolbar>
</template>
<script>
  import AppMenu from '@/components/AppMenu';
  import PageHeader from '@/components/PageHeader';
  import Util from '@/util';
  import { mapGetters } from 'vuex';
  import config from '../../config';
  export default {
    name: 'AppToolbar',
    components: {
      AppMenu,
      PageHeader,
    },
    data() {
      return {
        userDetails: [],
      };
    },
    computed: {
      ...mapGetters(['userData', 'checkRole']),
      toolbarColor() {
        return this.$vuetify.options.extra.mainNav;
      },
      getEnviroenment() {
        return config.ENV;
      },
      computeLogo() {
        return '/logo.svg';
      },
      userPicture() {
        return this.checkRole ? '/avatar/' + this.checkRole + '.jpg' : '/avatar/VIEWER.jpg';
      },
      role() {
        const role = this.checkRole ? this.$userRoles.find((u) => u.value === this.checkRole)['description'].toUpperCase() : '';
        const iscritto = this.userData ? (this.userData.Open != undefined && this.userData.Open ? ' OPEN' : '') : '';
        return role + iscritto;
      },
      items() {
        return [
          {
            icon: '',
            title: this.role,
            click: (e) => {},
          },
          {
            icon: 'exit_to_app',
            title: 'Logout',
            click: (e) => {
              window.getApp.$emit('APP_LOGOUT');
            },
          },
        ];
      },
    },
    methods: {
      handleDrawerToggle() {
        window.getApp.$emit('APP_DRAWER_TOGGLED');
      },
      handleFullScreen() {
        Util.toggleFullScreen();
      },
    },
  };
</script>

<style scoped>
  #header-toolbar .v-text-field--enclosed .v-input__slot {
    margin-bottom: 0;
  }
  .v-list__tile__action {
    min-width: 40px;
  }
</style>
